import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
const hubs = [{
  subtitle: "Entity Formation",
  title: "Strategic\nFoundations",
  description: "LLC and Corporation formation with custom operating agreements designed to protect your interests and define clear ownership.",
  buttonText: "Start Your Business",
  url: "/HomePage",
  bgClass: "bg-accent",
  subtitleClass: "text-chart-4"
}];
export default function BusinessPurchasesSalesOwnershipTransitions() {
  return;
}